import { ReactElement } from 'react';
import './List.scss';

import { BillSummary } from '@enview/interface/types/bills/Bill';
import NoBillResults from '../../LegislativeTracking/NoBillResults';
import BillListItem from './BillListItem';

type BillListProps = {
  bills: BillSummary[];
  noBillsMessage?: string;
  showAIStartingPoint?: boolean;
  isAISearch?: boolean;
  onStartingPointClick?: (phrase: string) => void;
};

const BillList = ({
  bills,
  noBillsMessage,
  showAIStartingPoint,
  isAISearch,
  onStartingPointClick,
}: BillListProps): ReactElement => {
  if (bills.length === 0) {
    return (
      <NoBillResults
        isAISearch={isAISearch}
        noBillsMessage={noBillsMessage}
        onStartingPointClick={onStartingPointClick}
        showAIStartingPoint={showAIStartingPoint}
      />
    );
  }
  return (
    <div className="row">
      <div className="col-12" id="bill-list">
        {bills.map((bill) => {
          return bill ? <BillListItem bill={bill} key={bill.id} /> : <></>;
        })}
      </div>
    </div>
  );
};

export default BillList;
